<script>
export default {
  props: {
    loading: Boolean,
    minHeight: {
      type: [Number, String],
      default: '50vh',
    },
    size: {
      type: Number,
      default: 42,
    },
  },
  computed: {
    mH() {
      if (typeof this.minHeight === 'number') {
        return this.minHeight + 'px'
      }
      return this.minHeight
    },
  },
}
</script>

<template>
  <div
    v-if="loading"
    class="d-flex align-items-center justify-content-center"
    :style="{ 'min-height': mH }"
  >
    <v-progress-circular indeterminate color="primary" :size="size" />
  </div>
</template>
